import { useNavigate } from 'react-router-dom';

import { Button } from 'components/common/button/button';
import { BALANCES_PAGE } from 'site-settings/site-navigation';
import CheckedLargeIcon from 'components/icons/CheckedLargeIcon';

import {
  StyledContainer,
  StyledHolder,
  StyledCircleIcon,
  StyledTitle,
} from '../../increase-storage-view.style';

const SuccessView = ({ closeModal }) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    navigate(BALANCES_PAGE);
    closeModal();
  };

  return (
    <StyledContainer>
      <StyledTitle>Success</StyledTitle>
      <StyledHolder>
        <StyledCircleIcon>
          <CheckedLargeIcon color="#fff" />
        </StyledCircleIcon>
        <h4 className="styled-heading">Transaction Successful</h4>
        <h6 className="styled-text">
          This account's storage deposit is now increased.
        </h6>
      </StyledHolder>

      <Button fullwidth onClick={onClickHandler}>
        Return Home
      </Button>
    </StyledContainer>
  );
};

export default SuccessView;
